// src/pages/Landing.jsx
import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../ManaTechAccessLanding.png";

const INDUSTRIES = ["AI & Automation", "Sustainability", "Supply Chain", "FinTech", "Healthcare", "Logistics", "Retail Tech", "Cybersecurity"];

export default function Landing() {
  return (
    <div style={{ background: "#000", overflowX: "hidden" }}>

      {/* ── HERO ── */}
      <section className="landing-hero">
        <div style={{ position: "absolute", top: -80, right: -80, width: 340, height: 340, borderRadius: "50%", background: "rgba(100,140,255,0.18)", filter: "blur(40px)" }} />
        <div style={{ position: "absolute", bottom: -60, left: -60, width: 260, height: 260, borderRadius: "50%", background: "rgba(80,120,255,0.15)", filter: "blur(30px)" }} />

        <div className="landing-hero-grid">
          <div className="landing-hero-card">
            <div style={{ fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.7)", letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 20 }}>
              INNOVATION + MENTORSHIP + EVENTS
            </div>
            <h1 style={{ fontFamily: "Barlow, sans-serif", fontSize: "clamp(32px, 8vw, 52px)", fontWeight: 800, color: "#fff", lineHeight: 1.1, marginBottom: 8 }}>
              The <span style={{ color: "#75faaa" }}>Demand-Led</span>
            </h1>
            <h1 style={{ fontFamily: "Barlow, sans-serif", fontSize: "clamp(32px, 8vw, 52px)", fontWeight: 800, color: "#fff", lineHeight: 1.1, marginBottom: 20 }}>
              Innovation Engine
            </h1>
            <p style={{ fontSize: 15, color: "rgba(255,255,255,0.75)", lineHeight: 1.7, marginBottom: 28 }}>
              Turning Enterprise Challenges into Scalable Startup Solutions
            </p>
            <div className="landing-cta-stack">
              <Link to="/signup?role=corporation" className="landing-cta landing-cta-primary">
                I am a Florida SMB Owner
              </Link>
              <Link to="/signup?role=startup" className="landing-cta landing-cta-outline">
                I am a Startup Founder
              </Link>
            </div>
          </div>

          <div className="landing-hero-media">
            <img
              src={heroImage}
              alt="Mana Tech Access — Innovation and Mentorship"
            />
          </div>
        </div>
      </section>

      {/* ── WHAT IS THE PLATFORM ── */}
      <section className="landing-section" style={{ background: "#0a0a0a", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <div style={{ maxWidth: 860, margin: "0 auto", textAlign: "center" }}>
          <p style={{ fontSize: "clamp(15px, 3.5vw, 17px)", color: "rgba(255,255,255,0.8)", lineHeight: 1.8, maxWidth: 760, margin: "0 auto" }}>
            Mana Tech Access operates a <strong style={{ color: "#fff" }}>demand-led innovation platform</strong> that converts verified corporate challenges into structured pilot engagements. By anchoring innovation in real business challenges, we reduce sourcing noise, vendor risk, and procurement friction — enabling Florida's enterprises to adopt technology with confidence while giving startups the <strong style={{ color: "#75faaa" }}>U.S. market validation</strong> required for institutional investment.
          </p>
        </div>
      </section>

      {/* ── METHODOLOGY ── */}
      <section className="landing-section" style={{ background: "linear-gradient(180deg, #0a0a0a 0%, #1a3a8f 60%, #2563d4 100%)" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#75faaa", textTransform: "uppercase", letterSpacing: "0.14em", marginBottom: 8 }}>OUR METHODOLOGY</div>
          <div style={{ marginBottom: 32 }}>
            <h2 style={{ fontFamily: "Barlow, sans-serif", fontSize: "clamp(22px, 5vw, 28px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", lineHeight: 1.2 }}>
              End-to-end · From challenge to scale
            </h2>
          </div>

          <div className="landing-steps">
            {[
              { num: "01", label: "Demand\nMapping", icon: "🔍" },
              { num: "02", label: "Match\n& Vet", icon: "→" },
              { num: "03", label: "Pilot\n& Deploy", icon: "✓" },
              { num: "04", label: "Scale\n& Grow", icon: "↗" },
            ].map((step, i) => (
              <div key={step.num} style={{
                background: i === 0 ? "#1a3a8f" : i === 1 ? "#1e50c8" : i === 2 ? "#2563d4" : "#2e73e8",
                padding: "18px 20px",
                borderRadius: i === 0 ? "12px 0 0 12px" : i === 3 ? "0 12px 12px 0" : 0,
                position: "relative"
              }}>
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.5)", fontWeight: 600, marginBottom: 6 }}>{step.num}</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#fff", whiteSpace: "pre-line", lineHeight: 1.3 }}>{step.label}</div>
                <div style={{ position: "absolute", top: 14, right: 14, color: "rgba(255,255,255,0.4)", fontSize: 16 }} aria-hidden="true">{step.icon}</div>
              </div>
            ))}
          </div>

          <div className="landing-step-copy">
            {[
              "We build a network of 500+ Innovation leaders across Florida to identify and prioritize critical enterprise challenges impacting efficiency and growth.",
              "We run targeted global scouting calls, vetting startups for technical feasibility and connecting pre-qualified solutions with the exact decision-makers responsible for implementation.",
              "We drive pilot structuring, stakeholder alignment, and procurement navigation to compress the timeline from first meeting to live deployment.",
              "We convert successful pilots into revenue relationships, giving startups paid U.S. reference customers and the performance data to attract venture capital."
            ].map((text, i) => (
              <p key={i} style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>{text}</p>
            ))}
          </div>
        </div>
      </section>

      {/* ── STRATEGIC OBJECTIVES ── */}
      <section className="landing-section" style={{ background: "linear-gradient(180deg, #2563d4 0%, #1a3a8f 50%, #000 100%)" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#75faaa", textTransform: "uppercase", letterSpacing: "0.14em", marginBottom: 10 }}>STRATEGIC OBJECTIVES</div>
          <h2 style={{ fontFamily: "Barlow, sans-serif", fontSize: "clamp(24px, 5.5vw, 32px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", marginBottom: 32, letterSpacing: "-0.01em", lineHeight: 1.2 }}>
            Where enterprise demand meets<br />startup innovation
          </h2>

          <div className="landing-objectives">
            <div style={{
              background: "rgba(255,255,255,0.08)", backdropFilter: "blur(16px)",
              border: "1px solid rgba(100,160,255,0.25)", borderRadius: 20, padding: "24px"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#2563d4", flexShrink: 0 }} />
                <div style={{ fontSize: 11, fontWeight: 700, color: "#60a5fa", textTransform: "uppercase", letterSpacing: "0.1em" }}>For Florida Enterprises</div>
              </div>
              <h3 style={{ fontFamily: "Barlow, sans-serif", fontSize: "clamp(18px, 4vw, 22px)", fontWeight: 800, color: "#fff", lineHeight: 1.2, marginBottom: 14 }}>
                Deploy with Confidence.<br />Accelerate Outcomes.
              </h3>
              <p style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", lineHeight: 1.7, marginBottom: 20 }}>
                Mana Tech Access gives Florida's mid-market and large enterprises direct access to vetted, high-impact technology solutions. Post your real business challenges and receive curated startup pitches — reducing vendor risk, procurement friction, and implementation time while delivering measurable ROI.
              </p>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {["Reduced Vendor Risk", "Faster Procurement", "Measurable ROI"].map(tag => (
                  <span key={tag} style={{
                    padding: "6px 12px", borderRadius: 99, fontSize: 11, fontWeight: 600,
                    background: "rgba(37,99,212,0.3)", color: "#93c5fd",
                    border: "1px solid rgba(37,99,212,0.4)"
                  }}>{tag}</span>
                ))}
              </div>
            </div>

            <div style={{
              background: "rgba(255,255,255,0.06)", backdropFilter: "blur(16px)",
              border: "1px solid rgba(117,250,170,0.25)", borderRadius: 20, padding: "24px"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#75faaa", flexShrink: 0 }} />
                <div style={{ fontSize: 11, fontWeight: 700, color: "#75faaa", textTransform: "uppercase", letterSpacing: "0.1em" }}>For Local & International Tech Startups</div>
              </div>
              <h3 style={{ fontFamily: "Barlow, sans-serif", fontSize: "clamp(18px, 4vw, 22px)", fontWeight: 800, color: "#fff", lineHeight: 1.2, marginBottom: 14 }}>
                Your First U.S. Customer.<br />Your Path to Scale.
              </h3>
              <p style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", lineHeight: 1.7, marginBottom: 20 }}>
                Mana Tech Access connects startups directly to verified enterprise challenges in Florida. Pitch your solution to decision-makers already seeking your technology — securing your first U.S. customer, validating product-market fit, and generating the proof points required to unlock institutional funding and scale.
              </p>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {["U.S. Market Entry", "PMF Validation", "VC-Ready Data"].map(tag => (
                  <span key={tag} style={{
                    padding: "6px 12px", borderRadius: 99, fontSize: 11, fontWeight: 600,
                    background: "rgba(117,250,170,0.15)", color: "#75faaa",
                    border: "1px solid rgba(117,250,170,0.3)"
                  }}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="landing-section" style={{ background: "#000", textAlign: "center", borderTop: "1px solid rgba(255,255,255,0.06)" }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#75faaa", textTransform: "uppercase", letterSpacing: "0.14em", marginBottom: 14 }}>Get started</div>
        <h2 style={{ fontFamily: "Barlow, sans-serif", fontSize: "clamp(24px, 6vw, 40px)", fontWeight: 800, color: "#fff", textTransform: "uppercase", marginBottom: 14, letterSpacing: "-0.01em", lineHeight: 1.15 }}>
          Ready to make a connection?
        </h2>
        <p style={{ fontSize: 15, color: "rgba(255,255,255,0.5)", marginBottom: 32, maxWidth: 460, marginLeft: "auto", marginRight: "auto", lineHeight: 1.6 }}>
          Corporations post their challenges. Startups pitch their solutions. Mana Tech Access facilitates the match.
        </p>
        <div className="landing-cta-row">
          <Link to="/signup?role=corporation" className="landing-cta landing-cta-lg landing-cta-gradient">
            I am a Florida SMB Owner
          </Link>
          <Link to="/signup?role=startup" className="landing-cta landing-cta-lg landing-cta-outline-muted">
            I am a Startup Founder
          </Link>
        </div>
      </section>

      {/* ── INDUSTRIES ── */}
      <section className="landing-section-sm" style={{ background: "#050a14", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div style={{ maxWidth: 900, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#75faaa", textTransform: "uppercase", letterSpacing: "0.14em", marginBottom: 18 }}>Industries on the platform</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center" }}>
            {INDUSTRIES.map(i => (
              <span key={i} style={{
                padding: "8px 16px", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 99,
                fontSize: 13, color: "rgba(255,255,255,0.5)", background: "rgba(255,255,255,0.03)"
              }}>{i}</span>
            ))}
          </div>
        </div>
      </section>

      <footer style={{ padding: "24px 16px", textAlign: "center", color: "rgba(255,255,255,0.2)", fontSize: 12, background: "#000", borderTop: "1px solid rgba(255,255,255,0.04)", lineHeight: 1.6 }}>
        © {new Date().getFullYear()} Mana Tech Access · Miami, Florida · manatech.io
        {" · "}
        <a
          href="https://manacommon.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "rgba(255,255,255,0.35)", textDecoration: "underline" }}
        >
          Privacy Policy
        </a>
      </footer>
    </div>
  );
}
